import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ErrorHint, Loadable, RootLoaderFallback } from "@/3514/components"

import { ECoachCalendarQueryKey as EQueryKey } from "./coach.calendar.api.config"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("./coach.calendar.container.accounts")
)

const Page: FC = (): ReactElement => (
    <ErrorBoundary fallback={<ErrorHint isVisible />} resetKeys={[EQueryKey.ZoomAccount(), EQueryKey.MsTeamsAccount()]}>
        <Loadable component={Container} loadingFallback={<RootLoaderFallback top="10%" />} />
    </ErrorBoundary>
)

Page.displayName = "CoachCalendarAccountsPage"

export { Page as CoachCalendarAccountsPage }
